export const TIME_TRACKING_KEYS = {
  all: ['time-tracking'] as const,
  byOrg: (orgId: string) => ['time-tracking', orgId] as const,
  activeTimer: (orgId: string) => ['time-tracking', orgId, 'active'] as const,
  taskEntries: (orgId: string, taskId: string) =>
    ['time-tracking', orgId, 'task', taskId, 'entries'] as const,
  projectEntries: (orgId: string, projectId: string, params: unknown) =>
    ['time-tracking', orgId, 'project', projectId, 'entries', params] as const,
  userEntries: (orgId: string, userId: string, params: unknown) =>
    ['time-tracking', orgId, 'user', userId, 'entries', params] as const,
};
